<template>
  <v-layout class="text-xs-left mr-6 pr-0" fill-height>
    <v-flex xs12 fill-height>
      <v-hover>
        <v-card
          class="modern-channel-card"
          slot-scope="{ hover }"
          :to="'/playlist/details/' + channel.id"
          :class="`elevation-${hover ? 6 : 2} mx-1 pb-4`"
          height="100%"
        >
          <v-card-title class="text-wrap course-heading">{{
            channel.name
          }}</v-card-title>
          <v-card-subtitle class="course-subhead"
            >Modules: {{ channel.total_modules }}</v-card-subtitle
          >
          <v-icon
            v-if="channel.thumbnailOption == 'icon'"
            class="pa-4 channel-icon"
            style="height: 200px"
            >fa-{{ channel.icon }}</v-icon
          >
          <div v-if="channel.thumbnailOption == 'image'" style="height: 200px; display: flex; justify-content: center; align-items: center; overflow: hidden;">
            <v-img
              :src="imgSrc"
              class="mx-auto"
              max-height="100%"
              max-width="100%"
            />
          </div>
          <v-card-text
            style="margin-bottom: 30px"
            v-if="channel.description != null"
            >{{ channel.description.substring(0, 100) + '..' }}</v-card-text
          >
          <v-btn
            style="position: absolute;bottom: 0; left: 50% ; transform: translateX(-50%); width: 100%; border-bottom-left-radius: 16px; border-bottom-right-radius: 16px;"
            :to="'/playlist/details/' + channel.id"
            color="primary"
            text
            class="mt-auto myplaylist-box-action-btn btn btn-primary add-course-button text-right"
            ><span>See Courses</span>
          </v-btn>
        </v-card>
      </v-hover>
    </v-flex>
  </v-layout>
</template>
<script>
import { IMPROVE_CONFIG } from '@/config.js';
import thumbSizes from '@/utils/thumbs.js';
export default {
  name: 'ChannelCard',
  props: {
    channel: {
      type: Object,
      default: null,
    },
  },
  computed: {
    imgSrc: function() {
      if (
        this.channel.thumbnailOption == 'image' &&
        this.channel.thumbnail.hasOwnProperty('data')
      ) {
        const imageRequest = JSON.stringify({
          bucket: `${IMPROVE_CONFIG.BUCKET}`,
          key: this.channel.thumbnail.data.key,
          edits: thumbSizes.medium,
        });
        const url = `${IMPROVE_CONFIG.SERVERLESS_IMAGE_HANDLER}/${btoa(
          imageRequest
        )}`;
        return url;
      }
    },
  },
};
</script>
<style>
.modern-channel-card {
  border-radius: 16px !important;
  background: #fff;
  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.08) !important;
  transition: all 0.18s ease !important;
  border: 1px solid #e2e8f0 !important;
}

.modern-channel-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.12) !important;
}
</style>
